import { render, staticRenderFns } from "./Prioridade.vue?vue&type=template&id=696d5cba"
import script from "./Prioridade.vue?vue&type=script&lang=js"
export * from "./Prioridade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports